/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdatePLanRequestPaymentFrequency } from './UpdatePLanRequestPaymentFrequency';
import {
    UpdatePLanRequestPaymentFrequencyFromJSON,
    UpdatePLanRequestPaymentFrequencyFromJSONTyped,
    UpdatePLanRequestPaymentFrequencyToJSON,
    UpdatePLanRequestPaymentFrequencyToJSONTyped,
} from './UpdatePLanRequestPaymentFrequency';
import type { UpdatePLanRequestPlan } from './UpdatePLanRequestPlan';
import {
    UpdatePLanRequestPlanFromJSON,
    UpdatePLanRequestPlanFromJSONTyped,
    UpdatePLanRequestPlanToJSON,
    UpdatePLanRequestPlanToJSONTyped,
} from './UpdatePLanRequestPlan';

/**
 * 
 * @export
 * @interface UpdatePLanRequest
 */
export interface UpdatePLanRequest {
    /**
     * 
     * @type {UpdatePLanRequestPlan}
     * @memberof UpdatePLanRequest
     */
    plan: UpdatePLanRequestPlan;
    /**
     * 
     * @type {UpdatePLanRequestPaymentFrequency}
     * @memberof UpdatePLanRequest
     */
    paymentFrequency?: UpdatePLanRequestPaymentFrequency;
}

/**
 * Check if a given object implements the UpdatePLanRequest interface.
 */
export function instanceOfUpdatePLanRequest(value: object): value is UpdatePLanRequest {
    if (!('plan' in value) || value['plan'] === undefined) return false;
    return true;
}

export function UpdatePLanRequestFromJSON(json: any): UpdatePLanRequest {
    return UpdatePLanRequestFromJSONTyped(json, false);
}

export function UpdatePLanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePLanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'plan': UpdatePLanRequestPlanFromJSON(json['plan']),
        'paymentFrequency': json['paymentFrequency'] == null ? undefined : UpdatePLanRequestPaymentFrequencyFromJSON(json['paymentFrequency']),
    };
}

export function UpdatePLanRequestToJSON(json: any): UpdatePLanRequest {
    return UpdatePLanRequestToJSONTyped(json, false);
}

export function UpdatePLanRequestToJSONTyped(value?: UpdatePLanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan': UpdatePLanRequestPlanToJSON(value['plan']),
        'paymentFrequency': UpdatePLanRequestPaymentFrequencyToJSON(value['paymentFrequency']),
    };
}

